import TheContainer from '@/containers/TheContainer'

export default [
  // Admin Global Scope
  {
    path: '/admin/email-templates',
    name: 'admin.emailTemplates',
    component: TheContainer,
    meta: {
      scopeType: 'global',
      breadcrumb: {
        to: { name: 'admin.emailTemplates.list' },
        text: 'Email Templates'
      }
    },
    children: [
      {
        path: 'list',
        name: 'admin.emailTemplates.list',
        component: () => import('./ListEmailTemplates.vue'),
        meta: {
          scopeType: 'global',
          permission: 'admin.email_template.list',
          label: 'Email Templates'
        }
      },
      {
        path: 'new',
        name: 'admin.emailTemplates.new',
        component: () => import('./NewEmailTemplate.vue'),
        meta: {
          scopeType: 'global',
          permission: 'admin.email_template.create',
          label: 'Create Email Template',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':emailType',
        name: 'admin.emailTemplates.edit',
        component: () => import('./EditEmailTemplate.vue'),
        meta: {
          scopeType: 'global',
          permission: 'admin.email_template.edit',
          label: 'Edit Email Template',
          breadcrumb: {
            text: (context) => {
              const template = context.store.getters['emailTemplates/template']
              return template ? template.email_type : 'Edit'
            }
          }
        }
      }
    ]
  },

  // Contract Manager Scope
  {
    path: '/contract-manager/:contractManagerId/email-templates',
    name: 'contractManager.emailTemplates',
    component: TheContainer,
    meta: {
      scopeType: 'contract-manager',
      breadcrumb: (context) => {
        const cm = context.store.getters['contractManager/contract_manager']
        const contractManagerId = context.route.params.contractManagerId

        // Trigger fetch if not loaded
        if (!cm || cm.id !== parseInt(contractManagerId)) {
          context.store.dispatch('contractManager/fetchContractManager', contractManagerId)
            .catch(err => console.error('Failed to load contract manager for breadcrumb:', err))
        }

        return [
          { to: { name: 'index' }, text: context.gettext('Dashboard') },
          { to: { name: 'contract_manager.list' }, text: 'Contract Managers' },
          {
            to: { name: 'contract_manager.detail', params: { id: contractManagerId } },
            text: cm && cm.id === parseInt(contractManagerId) ? cm.name : `Contract Manager #${contractManagerId}`
          }
        ]
      },
      breadcrumbMode: 'replace'
    },
    children: [
      {
        path: 'list',
        name: 'contractManager.emailTemplates.list',
        component: () => import('./ListEmailTemplates.vue'),
        meta: {
          scopeType: 'contract-manager',
          permission: 'contract_manager.email_template.list',
          label: 'Email Templates'
        }
      },
      {
        path: 'new',
        name: 'contractManager.emailTemplates.new',
        component: () => import('./NewEmailTemplate.vue'),
        meta: {
          scopeType: 'contract-manager',
          permission: 'contract_manager.email_template.create',
          label: 'Create Email Template',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':emailType',
        name: 'contractManager.emailTemplates.edit',
        component: () => import('./EditEmailTemplate.vue'),
        meta: {
          scopeType: 'contract-manager',
          permission: 'contract_manager.email_template.edit',
          label: 'Edit Email Template',
          breadcrumb: {
            text: (context) => {
              const template = context.store.getters['emailTemplates/template']
              return template ? template.email_type : 'Edit'
            }
          }
        }
      }
    ]
  },

  // Event Owner Scope
  {
    path: '/event-owner/:eventOwnerId/email-templates',
    name: 'eventOwner.emailTemplates',
    component: TheContainer,
    meta: {
      scopeType: 'event-owner',
      breadcrumb: (context) => {
        const eo = context.store.getters['eventOwner/event_owner']
        const eventOwnerId = context.route.params.eventOwnerId

        // Trigger fetch if not loaded
        if (!eo || eo.id !== parseInt(eventOwnerId)) {
          context.store.dispatch('eventOwner/fetchEventOwner', eventOwnerId)
            .catch(err => console.error('Failed to load event owner for breadcrumb:', err))
        }

        return [
          { to: { name: 'index' }, text: context.gettext('Dashboard') },
          { to: { name: 'event_owner.list' }, text: 'Event Owners' },
          {
            to: { name: 'event_owner.detail', params: { id: eventOwnerId } },
            text: eo && eo.id === parseInt(eventOwnerId) ? eo.company_name : `Event Owner #${eventOwnerId}`
          }
        ]
      },
      breadcrumbMode: 'replace'
    },
    children: [
      {
        path: 'list',
        name: 'eventOwner.emailTemplates.list',
        component: () => import('./ListEmailTemplates.vue'),
        meta: {
          scopeType: 'event-owner',
          permission: 'event_owner.email_template.list',
          label: 'Email Templates'
        }
      },
      {
        path: 'new',
        name: 'eventOwner.emailTemplates.new',
        component: () => import('./NewEmailTemplate.vue'),
        meta: {
          scopeType: 'event-owner',
          permission: 'event_owner.email_template.create',
          label: 'Create Email Template',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':emailType',
        name: 'eventOwner.emailTemplates.edit',
        component: () => import('./EditEmailTemplate.vue'),
        meta: {
          scopeType: 'event-owner',
          permission: 'event_owner.email_template.edit',
          label: 'Edit Email Template',
          breadcrumb: {
            text: (context) => {
              const template = context.store.getters['emailTemplates/template']
              return template ? template.email_type : 'Edit'
            }
          }
        }
      }
    ]
  }
]
